import gql from 'graphql-tag';

export const UpdateDispatchIssueCausedBy = gql`
  mutation UpdateDispatchIssueCausedByBulk($input: UpdateDispatchIssueCausedByBulkInput!) {
    updateDispatchIssueCausedByBulk(input: $input) {
      response {
        updated
        error {
          code
          message
          debug
        }
      }
    }
  }
`;
